import { ActionStore, dispatchable } from "higher-order/ActionStore";
import { observable, action } from "mobx";
import FormModelFactory from "shared/models/FormModelFactory";
import validations from "util/validations";

class ResendInvitationStore extends ActionStore {
    @observable resendInvitationForm;
    @observable invitationWasSent = false;

    constructor(props, dispatcher) {
        super(dispatcher);
        this.resendInvitationForm = FormModelFactory.form(props.resendInvitationForm)
            .withValidations({ email: validations.isRequired("Email").isEmail().isLengthLessThanOrEqual("Email", 128) })
            .create();
    }

    @dispatchable
    resendInvitation(e) {
        this.resendInvitationForm.save(e.data.dispatcher, action(() => {
            this.invitationWasSent = true;
        }));
    }
}

export default ResendInvitationStore;
